<template>
  <b-badge :style="badgeConfig.badgeStyle" class="po-status-badge">
    {{ badgeConfig.badgeLabel }}
  </b-badge>
</template>

<script>
import { PO_STATUS } from '../../constants/productStock'

export default {
  name: "PoStatusBadge",
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeConfig() {
      if (this.status === PO_STATUS.DRAFT) {
        return {
          badgeStyle: {
            backgroundColor: "#E3F2FD",
            color: "#3E495B",
          },
          badgeLabel: "รอรับสินค้า",
        };
      }
      if (this.status === PO_STATUS.PARTIALLY_RECEIVED) {
        return {
          badgeStyle: {
            backgroundColor: "#F6E8B2",
            color: "#3E495B",
          },
          badgeLabel: "รับสินค้าบางส่วน",
        };
      }
      if (this.status === PO_STATUS.CLOSED) {
        return {
          badgeStyle: {
            backgroundColor: "#D8EFDD",
            color: "#3E495B",
          },
          badgeLabel: "รับสินค้าครบแล้ว",
        };
      }
      if (this.status === PO_STATUS.EARLY_CLOSED) {
        return {
          badgeStyle: {
            backgroundColor: "#D8EFDD",
            color: "#3E495B",
          },
          badgeLabel: "ปิดก่อนกำหนด",
        };
      }
      if(this.status === PO_STATUS.CANCELED) {
        return {
          badgeStyle: {
            backgroundColor: "#E9ECEF",
            color: "#3E495B",
          },
          badgeLabel: "ยกเลิก",
        };
      }
      return {
        badgeStyle: {
          backgroundColor: "#E9ECEF",
          color: "#3E495B",
        },
        badgeLabel: "ไม่พบสถานะ",
      };
    },
  },
};
</script>

<style scoped>
.po-status-badge {
  font-size: 14px;
  font-weight: 400;
  padding: 0.35em 0.65em;
  border-radius: 20px;
}
</style>
